import React from 'react';
import PacienteForm from './PacienteForm';

const PacienteEdit = () => {
  return <PacienteForm isEdit={true} />;
};

export default PacienteEdit;